'use strict';
define([
  "dojo/_base/declare",
  "mw-filebrowser/actions/Action",
  "dojo/i18n!nls/mldoStringResource"
], function (declare, Action, MLDOStrings) {
  return declare(Action, {
    constructor: function (args) {
      args = args || {};
      var context = args.context;
      var makeActionAvailable = args.showAction || false;
      this.name =  MLDOStrings.sharingPageDeclineTitle;
      this.enabled = makeActionAvailable;
      this.label = MLDOStrings.sharingPageDeclineTitle;
      this.getInvitationDetailsMethod = args.getInvitationDetailsMethod;
      this.section = {
        id: "MISC",
        name: "MISC",
        allowSubMenu: false,
        forceSubMenu: false
      };
      this.isApplicableTo = function () {
        let invitationStatus;
        let invitationType;
        if (this.getInvitationDetailsMethod && typeof this.getInvitationDetailsMethod === "function" && this.getInvitationDetailsMethod()) {
          invitationStatus = this.getInvitationDetailsMethod().invitationStatus;
          invitationType = this.getInvitationDetailsMethod().invitationType;
        }
        if (invitationStatus === "ACCEPTED" || invitationType !== "PERSONAL") {
          this.enabled = false;
        } else {
          this.enabled =  makeActionAvailable && true;
        }
        return this.enabled;
      };
      this.callback = function () {
        let invitationDetails;
        if (this.getInvitationDetailsMethod && typeof this.getInvitationDetailsMethod === "function" && this.getInvitationDetailsMethod()) {
          invitationDetails = this.getInvitationDetailsMethod();
        }
        if (invitationDetails && typeof invitationDetails === "object") {
          context.handleDeclineInvitationAction(invitationDetails.invitationId, invitationDetails.invitationName);
        }
      };
    }
  });

});